/** WELDING PROJECTS THAT SELL™ — purchase configuration. */
export const CHECKOUT_URL = 'https://weldingprojectsthatsell.impultienda.ar/checkout'

export const PRICE = {
  value: 27,
  currency: 'USD',
  label: 'US$27',
  compareAtLabel: 'US$74',
  savingsLabel: 'US$47',
  discountLabel: '64%',
  perProjectLead: '30 complete welding projects that sell. US$27 total.',
  perProjectHighlight: 'Only US$0.90 per project.',
  perProjectNote: 'Average per project within the complete collection.',
  delivery: 'Receive all 6 PDF volumes and 5 bonus resources by email immediately after payment—with lifetime access.',
  note: 'One-time payment. No subscription. Free updates included.',
} as const

/** Launch discount shown in the "why today" list. */
export const LAUNCH_DISCOUNT = '64%'
